import _extends from '../../../../../@babel_runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import * as React from 'react';
import { forwardRef } from 'react';
import { S as Select } from '../../dist/Select-aab027f3.esm.js';
import { u as useStateManager } from '../../dist/useStateManager-7e1e8489.esm.js';
import { u as useAsync } from '../../dist/useAsync-c64f5536.esm.js';
export { u as useAsync } from '../../dist/useAsync-c64f5536.esm.js';
import '@emotion/react';
import 'react-dom';

var AsyncSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var stateManagedProps = useAsync(props);
  var selectProps = useStateManager(stateManagedProps);
  return /*#__PURE__*/React.createElement(Select, _extends({
    ref: ref
  }, selectProps));
});
var AsyncSelect$1 = AsyncSelect;

export { AsyncSelect$1 as default };
//# sourceMappingURL=react-select-async.esm.js.map
